import { ISharedDiagnosticReport } from '../../../types/diagnostics'
import { Text, View } from '@react-pdf/renderer'
import { styles } from '../styles'

const ContextBox = ({
  reportData,
}: {
  reportData: ISharedDiagnosticReport
}) => {
  return (
    <View style={styles.mYmediumContainer}>
      <Text style={[styles.text, styles.smallMb]}>
        {reportData?.title.charAt(0).toUpperCase() + reportData?.title.slice(1)}
      </Text>
      <Text style={styles.lightGrayText}>{reportData?.description}</Text>
    </View>
  )
}

export default ContextBox
